module.exports = __webpack_public_path__ + "static/media/SvgShareSimpler.ac387aa2.svg";